import { MovesValidationErrorDetail } from '@/services/files/endpoints/moves';
import { stringArrayToText } from '@/utils/arrayToText/stringArrayToText';
import { MOVE_TEMPLATE_TYPE, MoveTemplateType } from '../enum/TemplateType';
import { IProvider } from '../types/Provider.type';

export const getFileNameByType = (moveType: string): string => {
  if (moveType === 'creation') {
    return 'inclusao';
  }
  if (moveType === 'removal') {
    return 'exclusao';
  }
  return 'alteracao';
};

/**
 * Resolve o slug do template (`MOVE_TEMPLATE_TYPE`) a partir do provider e do tipo
 * de movimentação selecionados no formulário. Esse slug é enviado ao endpoint
 * autenticado `GET /templates/:type/download`.
 *
 * Regras:
 * - `creation` -> inclusão, `removal` -> exclusão, `update` -> alteração.
 * - Bradesco possui variantes apenas para inclusão e exclusão. Alteração (`update`)
 *   sempre usa o template padrão, mantendo o comportamento anterior.
 * - Odontoprev possui apenas o template de inclusão; demais tipos recaem no padrão.
 */
export const getMoveTemplateType = (
  provider: IProvider | null,
  movimentationType: string | null,
): MoveTemplateType | null => {
  if (!movimentationType) {
    return null;
  }

  const providerName = provider?.name?.toLowerCase() ?? '';
  const isBradesco = providerName.includes('bradesco');
  const isOdontoprev = providerName.includes('odontoprev');

  switch (movimentationType) {
    case 'creation':
      if (isBradesco) {
        return MOVE_TEMPLATE_TYPE.INCLUSION_BRADESCO;
      }
      if (isOdontoprev) {
        return MOVE_TEMPLATE_TYPE.INCLUSION_ODONTOPREV;
      }
      return MOVE_TEMPLATE_TYPE.INCLUSION;
    case 'removal':
      return isBradesco ? MOVE_TEMPLATE_TYPE.EXCLUSION_BRADESCO : MOVE_TEMPLATE_TYPE.EXCLUSION;
    case 'update':
      return MOVE_TEMPLATE_TYPE.ALTERATION;
    default:
      return null;
  }
};

export const getLines = ({ fields }: MovesValidationErrorDetail, fieldLineSeparator = '.') => {
  const lines = fields.map((field) => field.split(fieldLineSeparator).shift() || '-');

  return stringArrayToText(Array.from(new Set(lines)));
};

export const getFieldNames = ({ fields }: MovesValidationErrorDetail, fieldLineSeparator = '.') => {
  const lines = fields.map(
    (field) => field.split(fieldLineSeparator).slice(1).join(fieldLineSeparator) || '-',
  );

  return stringArrayToText(Array.from(new Set(lines)));
};
